import instance from "../instance";
import Cookies from "js-cookie";
import {
  LOGIN,
  REGION,
  ZONES,
  STATES,
  CITY,
  BRANCHES,
  SEGEMENT,
  MEMBERSENROLLEMENT,
  GET_DOWNLOAD_LINK,
  CAMPAIGN_TYPES,
  CAMPAIGNREPORT,
  DOWNLOADCAMPAIGNREPORT,
  DOWNLOADMEMBERSHIPREPORT,
  DOWNLOADTRANSACTIONREPORT,
  POINT_EXPIRY,
  LOYALY_PROGRAM_LIST,
  GET_LIABILITY_REPORT,
  GET_FORFEITURE_REPORT,
  GET_LOYALTY_PROGRAMS,
  GET_ALL_REDEEMPTION_REPORT,
  GET_ALL_TRANSACTION_REPORT,
  DOWNLOAD_REDEEMPTION_REPORT,
  DOWNLOAD_POINT_EXPIRY_REPORT,
  CALL_CENTER_QUERY,
  CALL_CENTER_STATUS,
  GET_CALL_CENTER_REPORT,
  DOWNLOAD_CALL_CENTER_REPORT,
  GET_OTP_REPORT,
  DOWNLOAD_OTP_REPORT,
  NEWMEMBERSENROLLEMENT,
  DOWNLOADNEWMEMBERSHIPREPORT,
  NF_UPLOAD,
  NF_MY_UPLOADS,
  NF_UPLOAD_LOG,
  NF_AUDIT,
  CHANNEL_STATUS,
  POINT_APPROVAL_REQUESTS,
  EXPIRY_SUMMARY,
  EXPIRY_UPCOMING,
  EXPIRY_UPCOMING_DOWNLOAD,
  EXPIRY_EXPIRED,
  EXPIRY_EXPIRED_DOWNLOAD,
  EXPIRY_OVERDUE,
  EXPIRY_OVERDUE_DOWNLOAD,
} from "../api";
import axios from "axios";

export const login = (payload) => {
  return instance.post(LOGIN, payload);
};

export const get_download_link = (payload) => {
  return instance.post(GET_DOWNLOAD_LINK, {
    param: payload?.payload,
    menu_id: payload?.menu_id,
  });
};

//QUERY
export const getRegion = (payload) => {
  return instance.get(`${REGION}?country_id=${payload?.id}`);
};
export const getZones = (payload) => {
  return instance.get(`${ZONES}?region_id=${payload?.id}`);
};
export const getStates = (payload) => {
  return instance.get(`${STATES}?zone_id=${payload?.id}`);
};

export const getCities = (payload) => {
  return instance.get(`${CITY}?state_id=${payload?.id}`);
};

export const getBranches = () => {
  return instance.get(`${BRANCHES}?company_id=3`);
};
export const getLoyaltyProgams = () => {
  return instance.get(`${GET_LOYALTY_PROGRAMS}`);
};

export const getSegements = () => {
  return instance.get(`${SEGEMENT}?company_id=3`);
};
//getLoyaltyProgamList
export const getLoyaltyProgamList = () => {
  return instance.get(`${LOYALY_PROGRAM_LIST}`);
};

export const getAllCallCenterQuery = () => {
  return instance.get(`${CALL_CENTER_QUERY}`);
};
export const getAllCallCenterStatus = () => {
  return instance.get(`${CALL_CENTER_STATUS}`);
};

export const getCallCenterReports = (payload) => {
  return instance.get(`${GET_CALL_CENTER_REPORT}?page=${payload?.page}`, {
    params: {
      from_date: payload?.fromDate,
      till_date: payload?.tillDate,
      query_type_id: payload?.queryType,
      query_status: payload?.queryStatus,
    },
  });
};

export const getLiabilityReports = (payload) => {
  return instance.get(`${GET_LIABILITY_REPORT}`, {
    params: {
      from_date: payload?.from_date,
      till_date: payload?.till_date,
      program_id: payload?.program_id,
      // limit: "" // Uncomment and set a value if needed
    },
  });
};

export const getMembersEnrollment = (payload) => {
  return instance.get(
    `${MEMBERSENROLLEMENT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&view=${payload?.view}&country=${payload?.country}&region=${payload?.region}&zone=${payload?.zone}&state=${payload?.state}&city=${payload?.city}&branch_code=${payload?.branch}&membership_id=${payload?.membershipId}&company_id=3&login=${payload?.loginStatus}&page=${payload?.page}`
  );
};

export const getPointExpiryReport = (payload) => {
  return instance.get(
    `${POINT_EXPIRY}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&view=${payload?.view}&loyalty_program_id=3&point_status=${payload?.pointType}&days=${payload?.days}&tier=${payload?.tier}&country=${payload?.country}&region=${payload?.region}&zone=${payload?.zone}&state=${payload?.state}&city=${payload?.city}&branch_code=${payload?.branch}&membership_id=${payload?.membershipId}&company_id=3&page=${payload?.page}&limit=20`
  );
};

export const getCampaignTypes = () => {
  return instance.get(`${CAMPAIGN_TYPES}`);
};

export const getCampaignReport = (payload) => {
  return instance.get(
    `${CAMPAIGNREPORT}?rule_type=${payload?.rule}& status=${payload?.status}&campaign_type=${payload?.campaign}&view=${payload?.view}&page=${payload?.page}`
  );
};
export const getForfeitureReport = (payload) => {
  return instance.get(
    `${GET_FORFEITURE_REPORT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&view=1&loyalty_program_id=${payload?.programs}&point_status=0`
  );
};

export const getRedeemptionReport = (payload) => {
  return instance.get(
    `${GET_ALL_REDEEMPTION_REPORT}?page=${payload?.page}&from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&report_type=${payload?.report}`
  );
};
// export const getMemebersTransactionReport = (payload) => {
//   return instance.get(
//     `${GET_ALL_TRANSACTION_REPORT}?page=${payload?.page}&from_date=${payload?.fromDate}&to_date=${payload?.tillDate}`
//   );
// };
export const getMemebersTransactionReport = (payload) => {
  return instance.get(
    `${GET_ALL_TRANSACTION_REPORT}?page=${payload?.page}&from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&date_type=${payload?.date_type}`
  );
};
// DOWNLOAD REPORTS
export const downloadCampaignReport = (payload) => {
  return instance.get(
    `${DOWNLOADCAMPAIGNREPORT}?rule_type=${payload?.rule}&status=${payload?.status}&campaign_type=${payload?.campaign}&view=${payload?.view}&count=${payload?.limit}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};
export const downloadCallCenterReport = (payload) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}${DOWNLOAD_CALL_CENTER_REPORT}`,
    {
      params: {
        from_date: payload?.fromDate,
        till_date: payload?.tillDate,
        query_type_id: payload?.queryType,
        query_status: payload?.queryStatus,
        limit: payload?.limit,
      },
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};


export const downloadTransactionReport = async (payload) => {
  return await instance.get(
    `${DOWNLOADTRANSACTIONREPORT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&count=${payload?.limit}&date_type=${payload?.date_type}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};
export const downloadRedemptionReport = (payload) => {
  console.log("payload", payload);
  return instance.get(
    `${DOWNLOAD_REDEEMPTION_REPORT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&report_type=${payload?.report}&count=${payload?.limit}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }

  );
};

export const downloadMembershipEnrollmentReport = (payload) => {
  return instance.get(
    `${DOWNLOADMEMBERSHIPREPORT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&view=${payload?.view}&country=${payload?.country}&count=${payload?.limit}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};
export const downloadPointExpiryReport = (payload) => {
  return instance.get(
    `${DOWNLOADMEMBERSHIPREPORT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&view=${payload?.view}&country=${payload?.country}&count=${payload?.limit}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};


export const getOtpReports = (payload) => {
  return instance.get(`${GET_OTP_REPORT}?page=${payload?.page}`, {
    params: {
      from_date: payload?.fromDate,
      to_date: payload?.tillDate,
      program_id: 3
    },
  });
};

export const downloadOtpReport = async (payload) => {
  return await instance.get(
    `${DOWNLOAD_OTP_REPORT}?from_date=${payload?.fromDate}&to_date=${payload?.toDate}&program_id=3&count=${payload?.limit}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};


export const getNewMembersEnrollment = (payload) => {
  return instance.get(
    `${NEWMEMBERSENROLLEMENT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&view=${payload?.view}&country=${payload?.country}&region=${payload?.region}&zone=${payload?.zone}&state=${payload?.state}&city=${payload?.city}&branch_code=${payload?.branch}&membership_id=${payload?.membershipId}&company_id=3&status=${payload?.loginStatus}&page=${payload?.page}`
  );
};

export const downloadNewMembershipEnrollmentReport = (payload) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}${DOWNLOADNEWMEMBERSHIPREPORT}?from_date=${payload?.fromDate}&to_date=${payload?.tillDate}&country_id=${payload?.country}&status=${payload?.loginStatus}&count=${payload?.limit}`,
    {
      headers: {
        "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};

export const getCustomerProfile = (payload) => {
  return instance.get(`get_customer_profile`, {
    params: {
      membership_id: payload?.membership_id,
    },
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

export const getCustomerTransactions = (payload) => {
  return instance.get(`get_customer_transactions`, {
    params: {
      membership_id: payload?.membership_id,
      from_date: payload?.from_date,
      to_date: payload?.to_date,
      page: payload?.page ?? 1,
      transaction_type: payload?.transaction_type,
    },
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

export const getCustomerLogQueries = (payload) => {
  return instance.get(`get_customer_log_queries`, {
    params: {
      membership_id: payload?.membership_id,
      page: payload?.page ?? 1,
      ...(payload?.ticket_number && { ticket_number: payload?.ticket_number }),
      ...(payload?.query_status && { query_status: payload?.query_status }),
    },
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

export const getQueryTypes = () => {
  return instance.get(`report/query_types`);
};

export const getSubQueryTypes = (query_type_id) => {
  return instance.get(`report/sub_query/${query_type_id}`);
};

export const logCustomerQuery = (payload) => {
  const formData = new FormData();
  formData.append("membership_id", payload.membership_id);
  formData.append("call_type", payload.call_type);
  formData.append("comm_type", payload.comm_type);
  formData.append("query_priority", payload.query_priority);
  formData.append("query_type", payload.query_type);
  formData.append("sub_query_type", payload.sub_query_type ?? "");
  formData.append("expected_closure_date", payload.expected_closure_date);
  formData.append("expected_closure_time", payload.expected_closure_time);
  formData.append("question", payload.question);
  formData.append("query_details", payload.query_details);
  formData.append("remark", payload.remark ?? "");
  if (payload.file) {
    formData.append("file", payload.file);
  }

  return instance.post(`log_customer_query`, formData, {
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateCustomerProfile = (payload) => {
  return instance.patch(`update_customer_profile`, payload, {
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

export const getBapLogByPayRef = (payment_ref) => {
  return instance.get(`get_bap_log_by_pay_ref/${payment_ref}`, {
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

export const getAdminAuditLogs = (payload) => {
  return instance.get(`admin_audit_logs`, {
    params: {
      page: payload?.page ?? 1,
      ...(payload?.membership_id && { membership_id: payload?.membership_id }),
      ...(payload?.admin_name && { admin_name: payload?.admin_name }),
      ...(payload?.action && { action: payload?.action }),
      ...(payload?.from && { from: payload?.from }),
      ...(payload?.to && { to: payload?.to }),
    },
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

export const pointsReversal = (payload) => {
  return instance.post(
    `report/points_reversal`,
    { payment_ref: payload?.payment_ref, request_id: payload?.request_id },
    {
      headers: {
        token: Cookies.get("token"),
      },
    }
  );
};

export const pointsDebiting = (payload) => {
  return instance.post(
    `report/points_debiting`,
    { payment_ref: payload?.payment_ref, request_id: payload?.request_id },
    {
      headers: {
        token: Cookies.get("token"),
      },
    }
  );
};

export const getCustomerTransactionsDownload = (payload) => {
  return instance.get(`get_customer_transactions`, {
    params: {
      membership_id: payload?.membership_id,
      from_date: payload?.from_date,
      to_date: payload?.to_date,
      transaction_type: payload?.transaction_type,
    },
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

//(Points Award)
// Upload
export const uploadNonFinancialTransactions = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/upload`,
    formData,
    {
      headers: {
        Token: Cookies.get("token"),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// Trigger processing for an upload
export const triggerNonFinancialProcessing = (upload_id) => {
  return axios.post(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/uploads/${upload_id}/trigger`,
    {},
    {
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get records for a specific upload
export const getNonFinancialUploadRecords = (upload_id, params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/uploads/${upload_id}/records`,
    {
      params: {
        per_page: params.perPage ?? 50,
        page: params.page ?? 1,
        ...(params.status && { status: params.status }),
        ...(params.membershipId && { membership_id: params.membershipId }),
        ...(params.reason && { reason: params.reason }),
        ...(params.dateFrom && { date_from: params.dateFrom }),
        ...(params.dateTo && { date_to: params.dateTo }),
      },
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get all uploads
export const getAllNonFinancialUploads = (params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/uploads`,
    {
      params: {
        per_page: params.perPage ?? 50,
        page: params.page ?? 1,
      },
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get my uploads
export const getMyNonFinancialUploads = (params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/my-uploads`,
    {
      params: {
        per_page: params.perPage ?? 50,
        page: params.page ?? 1,
      },
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get all records (report)
export const getNonFinancialUploadLog = (params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/records`,
    {
      params: {
        ...(params.paginate !== false && {
          per_page: params.perPage ?? 50,
          page: params.page ?? 1,
        }),
        paginate: params.paginate ?? true,
        ...(params.status && { status: params.status }),
        ...(params.membershipId && { membership_id: params.membershipId }),
        ...(params.reason && { reason: params.reason }),
        ...(params.dateFrom && { date_from: params.dateFrom }),
        ...(params.dateTo && { date_to: params.dateTo }),
      },
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get my records
export const getMyNonFinancialRecords = (params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/my-records`,
    {
      params: {
        per_page: params.perPage ?? 50,
        page: params.page ?? 1,
        paginate: true,
        ...(params.status && { status: params.status }),
        ...(params.membershipId && { membership_id: params.membershipId }),
        ...(params.reason && { reason: params.reason }),
        ...(params.dateFrom && { date_from: params.dateFrom }),
        ...(params.dateTo && { date_to: params.dateTo }),
      },
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get audit logs
export const getNonFinancialAudit = (params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/audits`,
    {
      params: {
        per_page: params.perPage ?? 50,
        page: params.page ?? 1,
        ...(params.status && { status: params.status }),
        ...(params.adminName && { admin_name: params.adminName }),
        ...(params.dateFrom && { date_from: params.dateFrom }),
        ...(params.dateTo && { date_to: params.dateTo }),
      },
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

// Get reasons
export const getNonFinancialReasons = (upload_id) => {
  return axios.get(
    `${process.env.REACT_APP_NF_BASE_URL}/report/non-financial-transaction/reasons`,
    {
      params: upload_id ? { file_upload_id: upload_id } : {},
      headers: {
        Token: Cookies.get("token"),
      },
    }
  );
};

export const reenrollMember = (payload) => {
  return instance.post(`report/reenroll-member`,
    { membership_id: String(payload.membership_id) },
    {
      headers: {
        "dashboard_key": process.env.REACT_APP_FIRSTBANK_TOKEN,
      },
    }
  );
};

// Transaction Channels
export const getChannelStatus = () => {
  return instance.get(`${CHANNEL_STATUS}`, {
    headers: {
      "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
    },
  });
};

// Points Approvals
export const createPointApprovalRequest = (payload) => {
  return instance.post(`${POINT_APPROVAL_REQUESTS}`, payload, {
    headers: {
      Token: Cookies.get("token"),
    },
  });
};

export const getPointApprovalRequests = (payload) => {
  return instance.get(`${POINT_APPROVAL_REQUESTS}`, {
    params: {
      page: payload?.page ?? 1,
      per_page: payload?.perPage ?? 50,
    },
    headers: {
      Token: Cookies.get("token"),
    },
  });
};

export const getPointApprovalRequest = (id) => {
  return instance.get(`${POINT_APPROVAL_REQUESTS}/${id}`, {
    headers: {
      Token: Cookies.get("token"),
    },
  });
};

export const rejectPointApprovalRequest = (id, payload) => {
  return instance.post(`${POINT_APPROVAL_REQUESTS}/${id}/reject`, payload, {
    headers: {
      Token: Cookies.get("token"),
    },
  });
};

export const approvePointApprovalRequest = (id, payload) => {
  return instance.post(`${POINT_APPROVAL_REQUESTS}/${id}/approve`, payload, {
    headers: {
      Token: Cookies.get("token"),
    },
  });
};

export const getExpiredPoints = (payload) => {
  return instance.get(`${EXPIRY_EXPIRED}`, {
    params: {
      ...(payload?.fromDate && { from_date: payload.fromDate }),
      ...(payload?.tillDate && { to_date: payload.tillDate }),
      ...(payload?.membershipId && { membership_id: payload.membershipId }),
      ...(payload?.limit && { limit: payload.limit }),
      page: payload?.page ?? 1,
    },
  });
};

export const getExpirySummary = () => {
  return instance.get(`${EXPIRY_SUMMARY}`);
};

// export const getUpcomingPointExpiry = (payload) => {
//   return instance.get(`${EXPIRY_UPCOMING}`, {
//     params: {
//       ...(payload?.fromDate && { from_date: payload.fromDate }),
//       ...(payload?.tillDate && { to_date: payload.tillDate }),
//       ...(payload?.membershipId && { membership_id: payload.membershipId }),
//       ...(payload?.days && { days: payload.days }),
//       ...(payload?.limit && { limit: payload.limit }),
//       page: payload?.page ?? 1,
//     },
//   });
// };

export const getUpcomingPointExpiry = (payload) => {
  console.log("EXPIRY REQUEST:", {
    from_date: payload?.fromDate,
    to_date: payload?.tillDate,
    // days: payload?.days,
    membership_id: payload?.membershipId,
  });

  return instance.get(`${EXPIRY_UPCOMING}`, {
    params: {
      ...(payload?.fromDate && { from_date: payload.fromDate }),
      ...(payload?.tillDate && { to_date: payload.tillDate }),
      ...(payload?.membershipId && {
        membership_id: payload.membershipId,
      }),
      ...(payload?.days && { days: payload.days }),
      ...(payload?.limit && { limit: payload.limit }),
      page: payload?.page ?? 1,
    },
  });
};


export const downloadExpiredPoints = (payload) => {
  return instance.get(`${EXPIRY_EXPIRED_DOWNLOAD}`, {
    params: {
      from_date: payload?.fromDate,
      to_date: payload?.tillDate,
      limit: payload?.limit,
    },
  });
};

export const downloadUpcomingPointExpiry = (payload) => {
  return instance.get(`${EXPIRY_UPCOMING_DOWNLOAD}`, {
    params: {
      from_date: payload?.fromDate,
      to_date: payload?.tillDate,
      limit: payload?.limit,
      ...(payload?.days && { days: payload.days }),
    },
  });
};

// Add to service/query/auth.js
export const getOverduePoints = (payload) => {
  return instance.get(EXPIRY_OVERDUE, {
    params: {
      ...(payload?.membershipId && { membership_id: payload.membershipId }),
      ...(payload?.limit && { limit: payload.limit }),
      page: payload?.page ?? 1,
    },
  });
};

export const downloadOverduePoints = (payload) => {
  return instance.get(EXPIRY_OVERDUE_DOWNLOAD, {
    params: {
      ...(payload?.membershipId && { membership_id: payload.membershipId }),
      ...(payload?.limit && { limit: payload.limit }),
    },
  });
};